$(document).ready(function () {
  if (typeof ScrollTrigger !== 'undefined') {
    ScrollTrigger.config({ ignoreMobileResize: true })
  }

  $(document).on('click', '.header-navigation__menu', function () {
    $(this).toggleClass('is-active')
  })

  $(document).on('click', '.header-burger-wrapper', function () {
    $(this).toggleClass('is-active')
    $('body').toggleClass('menu-active is-ovh')
  })

  const $header = $('.header')
  const onScroll = () => $header.toggleClass('is-active', window.scrollY > 20)
  onScroll()
  window.addEventListener('scroll', onScroll, { passive: true })

  $(document).on('click', '.faq-item__head', function () {
    const $item = $(this).closest('.faq-item')
    const $desc = $item.find('.faq-item__description')

    $item
      .siblings('.faq-item.is-active')
      .removeClass('is-active')
      .find('.faq-item__description')
      .stop(true, true)
      .slideUp(300)

    $item.toggleClass('is-active')
    $desc.stop(true, true).slideToggle(300)
  })

  const setFilled = (el) => {
    const $el = $(el)
    $el.toggleClass('is-filled', ($el.val() || '').toString().length > 0)
  }
  $('.inp-group__input').each(function () {
    setFilled(this)
  })
  $(document).on('input change blur', '.inp-group__input', function () {
    setFilled(this)
  })

  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  function validateEmail(email) {
    return EMAIL_RE.test(email)
  }

  const FREE_EMAIL_DOMAINS = new Set([
    // Google
    'gmail.com',
    'googlemail.com',
    // Yahoo
    'yahoo.com',
    'yahoo.co.uk',
    'yahoo.fr',
    'yahoo.de',
    'yahoo.es',
    'yahoo.it',
    'yahoo.com.br',
    'yahoo.com.au',
    'yahoo.ca',
    'ymail.com',
    'rocketmail.com',
    // Microsoft
    'hotmail.com',
    'hotmail.co.uk',
    'hotmail.fr',
    'hotmail.de',
    'hotmail.it',
    'hotmail.es',
    'outlook.com',
    'outlook.fr',
    'outlook.de',
    'outlook.es',
    'outlook.it',
    'live.com',
    'live.co.uk',
    'live.fr',
    'live.de',
    'msn.com',
    // Apple
    'icloud.com',
    'me.com',
    'mac.com',
    // AOL / Verizon legacy
    'aol.com',
    'aim.com',
    // Privacy-focused
    'proton.me',
    'protonmail.com',
    'pm.me',
    'tutanota.com',
    'tuta.io',
    // Other consumer providers (EU)
    'gmx.com',
    'gmx.net',
    'gmx.de',
    'gmx.us',
    'mail.com',
    'web.de',
    't-online.de',
    'freenet.de',
    'libero.it',
    'virgilio.it',
    'orange.fr',
    'wanadoo.fr',
    'free.fr',
    'sfr.fr',
    'laposte.net',
    'btinternet.com',
    'sky.com',
    'ntlworld.com',
    // Other consumer providers (US)
    'comcast.net',
    'verizon.net',
    'att.net',
    'sbcglobal.net',
    'cox.net',
    'earthlink.net',
    'juno.com',
    'bigpond.com',
    // Other
    'zoho.com',
    'fastmail.com',
    'fastmail.fm',
    'hey.com',
    'inbox.com',
  ])

  function isBusinessEmail(email) {
    const at = email.lastIndexOf('@')
    if (at < 0) return false
    const domain = email
      .slice(at + 1)
      .toLowerCase()
      .trim()
    if (!domain) return false
    return !FREE_EMAIL_DOMAINS.has(domain)
  }

  const ERROR_AUTO_DISMISS_MS = 5000

  const clearError = ($group) => {
    const timer = $group.data('errorTimer')
    if (timer) {
      clearTimeout(timer)
      $group.removeData('errorTimer')
    }
    $group.removeClass('inp-error').find('.inp-group__error').remove()
  }

  const showError = ($group, message) => {
    clearError($group)
    $group
      .addClass('inp-error')
      .append('<div class="inp-group__error">' + message + '</div>')
    const timer = setTimeout(() => {
      $group.removeClass('inp-error').find('.inp-group__error').remove()
      $group.removeData('errorTimer')
    }, ERROR_AUTO_DISMISS_MS)
    $group.data('errorTimer', timer)
  }

  function validateForm($form) {
    let valid = true
    $form.find('.inp-group').each(function () {
      clearError($(this))
    })

    const $nameInput = $form.find('input[name="name"]')
    if ($nameInput.length && !($nameInput.val() || '').trim()) {
      showError($nameInput.closest('.inp-group'), 'Enter your name')
      valid = false
    }

    const $emailInput = $form.find('input[name="email"]')
    if ($emailInput.length) {
      const v = ($emailInput.val() || '').trim()
      if (!v) {
        showError(
          $emailInput.closest('.inp-group'),
          'Enter your business email',
        )
        valid = false
      } else if (!validateEmail(v)) {
        showError(
          $emailInput.closest('.inp-group'),
          'Enter a valid business email',
        )
        valid = false
      } else if (!isBusinessEmail(v)) {
        showError(
          $emailInput.closest('.inp-group'),
          'Please use your business email',
        )
        valid = false
      }
    }

    const $terms = $form.find('.inp-group-checkbox input[type="checkbox"]')
    if ($terms.length && !$terms.is(':checked')) {
      showError($terms.closest('.inp-group'), 'Accept the Terms to continue')
      valid = false
    }

    return valid
  }

  let successDismissTimer = null

  const setButtonSending = ($form, sending) => {
    const $primary = $form.find('.contact-form__button .btn-primary')
    if ($primary.length) {
      if (sending) {
        if ($primary.data('originalHtml') == null) {
          $primary.data('originalHtml', $primary.html())
        }
        $primary.html(
          '<span class="btn-primary__spinner" aria-hidden="true"></span>Sending',
        )
        $primary.addClass('is-sending')
      } else {
        const original = $primary.data('originalHtml')
        if (original != null) $primary.html(original)
        $primary.removeClass('is-sending')
      }
      return
    }

    const $submit = $form.find('input[type="submit"]').not('.is-hidden')
    if (!$submit.length) return
    if (sending) {
      if ($submit.data('originalValue') == null) {
        $submit.data('originalValue', $submit.val())
      }
      $submit.val($submit.attr('data-wait') || 'Please wait...')
      $submit.prop('disabled', true)
    } else {
      const original = $submit.data('originalValue')
      if (original != null) $submit.val(original)
      $submit.prop('disabled', false)
    }
  }

  const hasCustomMessages = () =>
    $('.contact-us-message--success, .contact-us-message--alert').length > 0

  const showSuccess = ($form) => {
    if ($form && $form.hasClass('contact-form__form') && hasCustomMessages()) {
      const $success = $('.contact-us-message--success')
      $('.contact-us-message').removeClass('is-active')
      $success.addClass('is-active')
      if (successDismissTimer) clearTimeout(successDismissTimer)
      successDismissTimer = setTimeout(() => {
        $success.removeClass('is-active')
        successDismissTimer = null
      }, 15000)
      return
    }
    if (!$form) return
    const $wrap = $form.closest('.w-form')
    $form.hide()
    $wrap.find('.w-form-fail').hide()
    $wrap.find('.w-form-done').show()
  }

  const showAlert = ($form) => {
    if ($form && $form.hasClass('contact-form__form') && hasCustomMessages()) {
      $('.contact-us-message').removeClass('is-active')
      $('.contact-us-message--alert').addClass('is-active')
      return
    }
    if (!$form) return
    const $wrap = $form.closest('.w-form')
    $wrap.find('.w-form-done').hide()
    $wrap.find('.w-form-fail').show()
  }

  const resetForm = ($form) => {
    $form[0].reset()
    $form.find('.inp-group').each(function () {
      clearError($(this))
    })
    $form.find('.inp-group__input').each(function () {
      setFilled(this)
    })
  }

  // --- Attio integration -----------------------------------------------------
  // Every form submission is also POSTed to the Attio webhook, in addition to
  // the Webflow submission.
  const ATTIO_WEBHOOK_URL = 'https://attio.root-sustainability.xyz'

  const collectFormFields = ($form) => {
    const fields = {}
    $form.find('input, textarea, select').each(function () {
      const $input = $(this)
      const name = $input.attr('name')
      const type = $input.attr('type')
      if (!name || name === 'cf-turnstile-response') return
      if (type === 'checkbox') {
        fields[name] = $input.is(':checked')
      } else if (type === 'radio') {
        if ($input.is(':checked')) fields[name] = $input.val()
      } else if (type !== 'submit' && type !== 'hidden') {
        fields[name] = ($input.val() || '').trim()
      }
    })
    return fields
  }

  const sendToAttio = ($form) => {
    const formName =
      $form.attr('data-form-name') || $form.attr('data-name') || 'Contact'
    const payload = {
      ...collectFormFields($form),
      form_name: formName,
      source: window.location.href,
    }

    fetch(ATTIO_WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(async (res) => {
        if (res.ok) {
          console.log('[Attio] sent', res.status)
        } else {
          let body = ''
          try {
            body = await res.text()
          } catch (e) {}
          console.error('[Attio] HTTP error', res.status, res.statusText, body)
        }
      })
      .catch((err) => {
        console.error('[Attio] request failed (CORS or network):', err)
      })
  }

  function sendForm($form) {
    // Mirror every submission to Attio, in addition to Webflow.
    try {
      sendToAttio($form)
    } catch (e) {
      console.error('[Attio] failed before request:', e)
    }

    const endPointId = $('html').attr('data-wf-site')
    const pageId = $('html').attr('data-wf-page')
    const elementId = $form.attr('data-wf-element-id') || ''
    const domain = window.location.hostname
    const url = 'https://webflow.com/api/v1/form/' + endPointId
    const formName = $form.attr('data-name') || 'Contact'

    const data = new URLSearchParams()
    data.append('name', formName)
    data.append('source', window.location.href)
    data.append('test', 'false')
    data.append('dolphin', 'false')
    if (pageId) data.append('pageId', pageId)
    if (elementId) data.append('elementId', elementId)
    data.append('domain', domain)

    $form.find('input, textarea, select').each(function () {
      const $input = $(this)
      const name = $input.attr('name')
      const type = $input.attr('type')

      if (!name || name === 'cf-turnstile-response') return

      if (type === 'checkbox') {
        data.append(
          'fields[' + name + ']',
          $input.is(':checked') ? 'true' : 'false',
        )
      } else if (type === 'radio') {
        if ($input.is(':checked'))
          data.append('fields[' + name + ']', $input.val())
      } else if (type !== 'submit' && type !== 'hidden') {
        data.append('fields[' + name + ']', ($input.val() || '').trim())
      }
    })

    const turnstileResponse = $form
      .find('input[name="cf-turnstile-response"]')
      .val()
    if (turnstileResponse) {
      data.append('fields[cf-turnstile-response]', turnstileResponse)
    }
    data.append('fields[submit_url]', window.location.href)

    $form.addClass('is-sending')
    setButtonSending($form, true)

    $.ajax({
      url: url,
      method: 'POST',
      contentType: 'application/x-www-form-urlencoded',
      data: data.toString(),
      success: function () {
        $form.removeClass('is-sending')
        setButtonSending($form, false)
        resetForm($form)
        showSuccess($form)
      },
      error: function () {
        $form.removeClass('is-sending')
        setButtonSending($form, false)
        showAlert($form)
      },
    })
  }

  $(document).on('click', '.contact-us-message .btn-bordered', function (e) {
    const $btn = $(this)
    const $msg = $btn.closest('.contact-us-message')
    const href = $btn.attr('href')
    if (!href || href === '#') e.preventDefault()
    $msg.removeClass('is-active')
    if ($msg.hasClass('contact-us-message--success') && successDismissTimer) {
      clearTimeout(successDismissTimer)
      successDismissTimer = null
    }
  })

  $(document).on(
    'input change',
    '.inp-group.inp-error input, .inp-group.inp-error textarea',
    function () {
      clearError($(this).closest('.inp-group'))
    },
  )

  $(document).on('submit', 'form[data-form="custom"]', function (e) {
    e.preventDefault()
    e.stopImmediatePropagation()
    const $form = $(this)
    if ($form.hasClass('is-sending')) return
    if (!validateForm($form)) return
    sendForm($form)
  })

  $(document).on('click', '[data-form-submit]', function (e) {
    e.preventDefault()
    if ($(this).hasClass('is-sending')) return
    const $form = $(this).closest('form')
    if (!$form.length) return
    if (!validateForm($form)) return
    sendForm($form)
  })
})

const onLayoutResize = (callback, delay = 150) => {
  let width = window.innerWidth
  let timer = null

  window.addEventListener('resize', () => {
    const nextWidth = window.innerWidth
    const widthChanged = Math.abs(nextWidth - width) > 1
    width = nextWidth

    if (!widthChanged && window.matchMedia('(max-width: 767px)').matches) {
      return
    }

    clearTimeout(timer)
    timer = setTimeout(callback, delay)
  })
}

document.addEventListener('DOMContentLoaded', () => {
  const logo = document.querySelector('.logo')
  if (!logo) return

  const initialTrack = logo.querySelector('.logo__items')
  if (!initialTrack) return

  const isMobile = window.matchMedia('(max-width: 479px)').matches
  const speed = 60

  const animateRow = (rowEl, direction) => {
    rowEl.innerHTML += rowEl.innerHTML
    const imgs = rowEl.querySelectorAll('img')
    let loaded = 0
    const start = () => {
      // Drive the marquee with a CSS @keyframes animation, not GSAP. WebKit runs
      // accelerated transform animations on the compositor thread, so they stay
      // smooth even when the main thread is busy (ScrollTrigger, scroll, etc.) —
      // a JS/rAF tween drops frames under that load and stutters on Safari.
      // Content is duplicated, so translateX(-50%) = exactly one set (seamless).
      const distance = rowEl.scrollWidth / 2
      rowEl.style.animationDuration = distance / speed + 's'
      if (direction === 1) rowEl.style.animationDirection = 'reverse'
      rowEl.classList.add('is-marquee')
    }
    if (imgs.length === 0) return start()
    imgs.forEach((img) => {
      if (img.complete) {
        if (++loaded === imgs.length) start()
      } else {
        img.addEventListener('load', () => {
          if (++loaded === imgs.length) start()
        })
        img.addEventListener('error', () => {
          if (++loaded === imgs.length) start()
        })
      }
    })
  }

  if (isMobile) {
    const items = Array.from(initialTrack.querySelectorAll('.logo-item'))
    const mid = Math.ceil(items.length / 2)

    initialTrack.remove()

    const row1 = document.createElement('div')
    row1.className = 'logo__items'
    items.slice(0, mid).forEach((it) => row1.appendChild(it))

    const row2 = document.createElement('div')
    row2.className = 'logo__items'
    row2.style.marginTop = '1rem'
    items.slice(mid).forEach((it) => row2.appendChild(it))

    logo.appendChild(row1)
    logo.appendChild(row2)

    animateRow(row1, -1)
    animateRow(row2, -1)
  } else {
    animateRow(initialTrack, -1)
  }
})

document.addEventListener('DOMContentLoaded', () => {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined')
    return
  if (window.matchMedia('(max-width: 479px)').matches) return
  gsap.registerPlugin(ScrollTrigger)

  const section = document.querySelector('.solution-section')
  if (!section) return

  const rows = section.querySelectorAll('.solution__row')

  rows.forEach((row) => {
    const items = row.querySelectorAll('.solution-item')
    if (items.length < 2) return

    const left = items[0]
    const right = items[1]

    gsap.set(left, { xPercent: -40, autoAlpha: 0.6 })
    gsap.set(right, { xPercent: 40, autoAlpha: 0.6 })

    gsap.to([left, right], {
      xPercent: 0,
      autoAlpha: 1,
      ease: 'none',
      scrollTrigger: {
        trigger: row,
        start: 'top 90%',
        end: 'center 55%',
        scrub: 1,
      },
    })
  })

  window.addEventListener('load', () => ScrollTrigger.refresh())
})

// Header reveal on scroll (desktop ≥480px only; ≤479px untouched).
// In the hero the header is position:absolute and scrolls away with the page.
// It then "lands" fixed at the top, flying in from above:
//   - if a [data-block-header-pin] block exists: only once its BOTTOM passes the
//     viewport top (header stays hidden while the block is on screen);
//   - otherwise: after scrolling past the header height + 10px.
// Scrolling back up above the threshold removes the class → instant hide.
document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header')
  if (!header) return

  const mq = window.matchMedia('(min-width: 480px)')
  const blockEl = document.querySelector('[data-block-header-pin]')

  let landed = false
  const setLanded = (state) => {
    if (state === landed) return
    landed = state
    header.classList.toggle('is-landed', state)
  }

  const threshold = () => {
    if (blockEl) {
      // document Y of the block's bottom edge (read live, so pin spacers /
      // layout shifts are accounted for automatically)
      return window.scrollY + blockEl.getBoundingClientRect().bottom
    }
    return header.offsetHeight + 10
  }

  const update = () => {
    if (!mq.matches) {
      setLanded(false) // mobile — leave the header untouched
      return
    }
    setLanded(window.scrollY >= threshold())
  }

  update()
  window.addEventListener('scroll', update, { passive: true })
  window.addEventListener('resize', update)
})

// document.addEventListener('DOMContentLoaded', () => {
//   const wrap = document.querySelector('.wave-text')
//   if (!wrap) return

//   const PATH_ID = 'wave-text-path'
//   const CLIP_ID = 'wave-text-clip'
//   const OVERPASS_CLIP_ID = 'wave-text-overpass-clip'
//   const RIBBON_D =
//     'M84.8318 126.638C140.523 77.9897 224.39 28.4482 334.743 28.4521C398.896 28.4545 450.311 53.8344 496.091 88.8824C540.91 123.194 582.916 169.051 625.523 209.874C669.031 251.559 714.939 289.977 771.051 314.769C826.732 339.372 893.571 351.028 979.572 337.213C1062.09 323.958 1130.67 277.936 1177.36 224.982C1151.02 218.695 1128.89 209.317 1110.98 197.628C1068.19 169.685 1048.96 127.429 1059.87 86.5462C1070.58 46.4282 1108.29 15.3688 1162.73 3.98045C1189.68 -1.65818 1213.33 -1.41774 1232.89 5.41652C1253.03 12.4564 1267.51 26.0717 1275.76 44.0536C1291.45 78.2694 1283.22 124.349 1262.97 167.783C1258.97 176.365 1254.4 185.045 1249.31 193.744C1266.44 194.196 1285.16 193.557 1305.53 191.591C1389.59 183.479 1500.18 152.945 1639.58 85.932L1656.91 121.983C1514.58 190.404 1399.37 222.721 1309.37 231.406C1277.7 234.462 1248.96 234.605 1223.16 232.292C1171.25 299.327 1088.56 360.219 985.917 376.707C892.576 391.7 817.893 379.197 754.885 351.357C692.307 323.707 642.358 281.399 597.851 238.757C552.443 195.252 514.276 153.18 471.776 120.643C430.238 88.8431 387.188 68.4545 334.742 68.4525C237.093 68.449 162.208 112.159 111.147 156.763C85.6429 179.042 66.3286 201.346 53.4215 218.044C46.9779 226.38 42.159 233.282 38.9898 238.035C37.4059 240.41 36.2362 242.246 35.4839 243.451C35.1079 244.053 34.8362 244.498 34.6696 244.773C34.5865 244.91 34.5294 245.006 34.4986 245.057C34.4894 245.073 34.4813 245.084 34.4768 245.092C34.4587 245.074 33.867 244.717 17.238 234.954C0.16209 224.928 -0.00316855 224.821 3.68072e-05 224.812C0.00224779 224.808 0.00806514 224.799 0.0124894 224.791C0.0213283 224.776 0.0319595 224.758 0.0441665 224.738C0.0686478 224.696 0.0998296 224.644 0.137844 224.58C0.213872 224.452 0.31703 224.28 0.447127 224.065C0.707552 223.635 1.07666 223.032 1.55341 222.268C2.50677 220.741 3.89274 218.569 5.70923 215.845C9.34094 210.398 14.7023 202.73 21.7744 193.581C35.8991 175.308 56.9605 150.985 84.8318 126.638ZM1170.92 43.1332C1126.26 52.4758 1104.17 75.6907 1098.52 96.8582C1093.08 117.261 1100.95 143.302 1132.85 164.135C1149.91 175.271 1173.62 184.58 1204.65 189.68C1213.37 176.706 1220.76 163.659 1226.72 150.882C1245.35 110.908 1247.66 78.7342 1239.4 60.7315C1235.67 52.6042 1229.54 46.6189 1219.69 43.1767C1209.25 39.5291 1193.51 38.4065 1170.92 43.1332ZM34.478 245.092L34.474 245.1L34.4717 245.102C34.4717 245.102 34.4738 245.097 34.4768 245.092L34.478 245.092Z'
//   const PATH_D =
//     'M 16 235 C 78 128 190 48 335 49 C 470 49 552 150 624 222 C 724 320 832 370 984 356 C 1078 348 1158 300 1213 226 C 1230 203 1249 184 1258 160 C 1267 136 1278 103 1265 80 C 1252 57 1210 23 1180 23 C 1150 23 1097 57 1085 80 C 1073 103 1084 139 1110 160 C 1136 181 1187 201 1238 206 C 1289 211 1358 203 1414 192 C 1496 174 1576 138 1668 95'
//   const OVERPASS_D =
//     'M 1213 226 C 1230 203 1249 184 1258 160 C 1267 136 1278 103 1265 80 C 1252 57 1210 23 1180 23 C 1150 23 1097 57 1085 80 C 1073 103 1084 139 1110 160 C 1136 181 1187 201 1238 206'
//   const TEXT = 'No perfect data required. We start with what you have.'
//   const SEP = '   *   '
//   const UNIT = TEXT + SEP

//   wrap.innerHTML = `
//     <svg viewBox="0 0 1657 384" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
//       <defs>
//         <clipPath id="${CLIP_ID}">
//           <path d="${RIBBON_D}"/>
//         </clipPath>
//         <clipPath id="${OVERPASS_CLIP_ID}">
//           <rect x="1030" y="0" width="300" height="230"/>
//         </clipPath>
//       </defs>
//       <path class="wave-text__shape" d="${RIBBON_D}"/>
//       <path id="${PATH_ID}" class="wave-text__path" d="${PATH_D}"/>
//       <g clip-path="url(#${CLIP_ID})">
//         <text class="wave-text__text" dy="0.34em">
//           <textPath href="#${PATH_ID}" startOffset="0"></textPath>
//         </text>
//       </g>
//       <path class="wave-text__overpass" d="${OVERPASS_D}"/>
//       <g clip-path="url(#${OVERPASS_CLIP_ID})">
//         <text class="wave-text__text wave-text__text--overpass" dy="0.34em">
//           <textPath href="#${PATH_ID}" startOffset="0"></textPath>
//         </text>
//       </g>
//     </svg>
//   `

//   if (typeof gsap === 'undefined') return

//   const path = wrap.querySelector(`#${PATH_ID}`)
//   const textEl = wrap.querySelector('.wave-text__text')
//   const textPaths = wrap.querySelectorAll('textPath')

//   const start = () => {
//     textPaths.forEach((textPath) => {
//       textPath.textContent = UNIT
//     })
//     const unitLen = textEl.getComputedTextLength()
//     const pathLen = path.getTotalLength()
//     if (!unitLen || !pathLen) {
//       requestAnimationFrame(start)
//       return
//     }

//     const repeats = Math.max(2, Math.ceil((pathLen + unitLen) / unitLen))
//     textPaths.forEach((textPath) => {
//       textPath.textContent = UNIT.repeat(repeats)
//     })
//     const unitPct = (unitLen / pathLen) * 100

//     gsap.killTweensOf(textPaths)
//     gsap.set(textPaths, { attr: { startOffset: `-${unitPct}%` } })
//     gsap.to(textPaths, {
//       attr: { startOffset: '0%' },
//       duration: unitLen / 80,
//       ease: 'none',
//       repeat: -1,
//     })
//   }

//   if (document.fonts && document.fonts.ready) {
//     document.fonts.ready.then(start)
//   } else {
//     start()
//   }
// })

document.addEventListener('DOMContentLoaded', () => {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined')
    return
  if (window.matchMedia('(max-width: 479px)').matches) return
  gsap.registerPlugin(ScrollTrigger)

  const items = document.querySelectorAll(
    '.customer-stories__items .customer-stories-item',
  )
  if (!items.length) return

  const getBaseRotate = (el) => {
    const t = window.getComputedStyle(el).transform
    if (!t || t === 'none') return 0
    const m = new DOMMatrix(t)
    return Math.atan2(m.b, m.a) * (180 / Math.PI)
  }

  items.forEach((item, i) => {
    const base = getBaseRotate(item)
    const direction = base >= 0 ? 1 : -1
    const spreadRotate = base + direction * 8
    const spreadX = direction * 60

    gsap.fromTo(
      item,
      { rotate: spreadRotate, x: spreadX },
      {
        rotate: base,
        x: 0,
        ease: 'none',
        scrollTrigger: {
          trigger: item,
          start: 'top 90%',
          end: 'center 60%',
          scrub: 1,
        },
      },
    )
  })
})

document.addEventListener('DOMContentLoaded', () => {
  const mql = window.matchMedia('(max-width: 479px)')
  const items = Array.from(document.querySelectorAll('.the-platform-item'))
  if (!items.length) return

  const equalize = () => {
    items.forEach((it) => (it.style.minHeight = ''))
    if (!mql.matches) return
    const max = Math.max(
      ...items.map((it) => it.getBoundingClientRect().height),
    )
    items.forEach((it) => (it.style.minHeight = `${max}px`))
  }

  equalize()
  window.addEventListener('load', equalize)
  onLayoutResize(equalize)
  items.forEach((it) => {
    it.querySelectorAll('img').forEach((img) => {
      if (!img.complete) img.addEventListener('load', equalize)
    })
  })
})

document.addEventListener('DOMContentLoaded', () => {
  const mql = window.matchMedia('(max-width: 479px)')
  const items = Array.from(document.querySelectorAll('.capabilities-item'))
  if (!items.length) return

  const equalize = () => {
    items.forEach((it) => (it.style.minHeight = ''))
    if (!mql.matches) return
    const max = Math.max(
      ...items.map((it) => it.getBoundingClientRect().height),
    )
    items.forEach((it) => (it.style.minHeight = `${max}px`))
    if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh()
  }

  equalize()
  window.addEventListener('load', equalize)
  onLayoutResize(equalize)
  items.forEach((it) => {
    it.querySelectorAll('img').forEach((img) => {
      if (!img.complete) img.addEventListener('load', equalize)
    })
  })
})

document.addEventListener('DOMContentLoaded', () => {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined')
    return
  if (window.matchMedia('(max-width: 479px)').matches) return
  gsap.registerPlugin(ScrollTrigger)

  const wrap = document.querySelector('.the-platform__items')
  if (!wrap) return
  const items = Array.from(wrap.querySelectorAll('.the-platform-item'))
  if (items.length < 2) return

  const STEP_SCALE = 0.04
  const STEP_Y = 12
  const stickyTop = parseFloat(getComputedStyle(items[0]).top) || 67

  gsap.set(items, { transformOrigin: 'top center', willChange: 'transform' })

  const update = () => {
    const vh = window.innerHeight
    const stackRange = Math.max(1, vh - stickyTop)

    const stickyTops = items.map((item) => {
      const rect = item.getBoundingClientRect()
      const appliedY = parseFloat(gsap.getProperty(item, 'y')) || 0
      return rect.top - appliedY
    })

    items.forEach((item, i) => {
      let steps = 0
      for (let j = i + 1; j < items.length; j++) {
        const traveled = vh - stickyTops[j]
        steps += Math.max(0, Math.min(1, traveled / stackRange))
      }
      gsap.set(item, {
        scale: 1 - steps * STEP_SCALE,
        y: -steps * STEP_Y,
      })
    })
  }

  ScrollTrigger.create({
    trigger: wrap,
    start: 'top bottom',
    end: 'bottom top',
    onUpdate: update,
    onRefresh: update,
  })

  update()
  window.addEventListener('load', () => ScrollTrigger.refresh())
})

document.addEventListener('DOMContentLoaded', () => {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined')
    return
  gsap.registerPlugin(ScrollTrigger)

  const section = document.querySelector('.why-section')
  if (!section) return

  const lists = Array.from(section.querySelectorAll('.why-items__list'))
  if (!lists.length) return

  const columns = lists.map((list) =>
    Array.from(list.querySelectorAll('.why-item')),
  )
  const count = Math.min(...columns.map((c) => c.length))
  if (count < 2) return

  const parseColor = (str) => {
    if (!str) return { r: 0, g: 0, b: 0 }
    if (str[0] === '#') {
      const hex =
        str.length === 4
          ? str
              .slice(1)
              .split('')
              .map((c) => c + c)
              .join('')
          : str.slice(1)
      const n = parseInt(hex, 16)
      return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 }
    }
    const m = str.match(/(\d+(?:\.\d+)?)/g)
    if (!m) return { r: 0, g: 0, b: 0 }
    return { r: +m[0] || 0, g: +m[1] || 0, b: +m[2] || 0 }
  }
  const lerpColor = (a, b, t) => ({
    r: Math.round(a.r + (b.r - a.r) * t),
    g: Math.round(a.g + (b.g - a.g) * t),
    b: Math.round(a.b + (b.b - a.b) * t),
  })
  const toRgb = (c) => `rgb(${c.r}, ${c.g}, ${c.b})`
  const GREEN_TIERS = ['#AFCABB', '#C6DCD0'].map(parseColor)
  const WHITE_TIERS = ['#EFEFEC', '#F3F3F1'].map(parseColor)

  columns.forEach((items) => {
    items.forEach((it) => {
      it.style.backgroundColor = ''
      it.style.borderColor = ''
      const cs = window.getComputedStyle(it)
      it._origBg = parseColor(cs.backgroundColor)
      it._origBorder = parseColor(cs.borderColor)
      it._isGreen = it.classList.contains('bg-green')
    })
  })

  const equalizeRowHeights = () => {
    columns.forEach((items) => {
      items.forEach((it) => {
        it.style.minHeight = ''
      })
    })
    const rowCount = Math.min(...columns.map((c) => c.length))
    for (let r = 0; r < rowCount; r++) {
      const heights = columns.map((items) => items[r].offsetHeight)
      const max = Math.max(...heights)
      columns.forEach((items) => {
        items[r].style.minHeight = `${max}px`
      })
    }
  }

  const layout = () => {
    lists.forEach((list, listIdx) => {
      const items = columns[listIdx]
      items.forEach((it) => {
        it.style.position = ''
        it.style.top = ''
        it.style.left = ''
        it.style.width = ''
        it.style.opacity = ''
        it.style.visibility = ''
        gsap.set(it, {
          clearProps:
            'transform,filter,opacity,zIndex,backgroundColor,borderColor',
        })
      })
    })
    equalizeRowHeights()
    lists.forEach((list, listIdx) => {
      const items = columns[listIdx]
      const maxH = Math.max(...items.map((it) => it.offsetHeight))
      list.style.position = 'relative'
      list.style.minHeight = `${maxH}px`
      list.style.overflow = 'visible'
      items.forEach((it) => {
        it.style.position = 'absolute'
        it.style.top = '0'
        it.style.left = '0'
        it.style.width = '100%'
      })
    })
  }

  const ACTIVE_SCALE_END = 1.1
  const ACTIVE_Y_END = -60
  const STACK_DEPTH = 2
  const STACK_OFFSET_PX = 14
  const STACK_SCALE_STEP = 0.03

  const tierColorAt = (it, t) => {
    const tiers = it._isGreen ? GREEN_TIERS : WHITE_TIERS
    if (t <= 0) return it._origBg
    if (t >= STACK_DEPTH) return tiers[STACK_DEPTH - 1]
    if (t <= 1) return lerpColor(it._origBg, tiers[0], t)
    return lerpColor(tiers[0], tiers[1], t - 1)
  }
  const tierBorderAt = (it, t) => {
    const tiers = it._isGreen ? GREEN_TIERS : WHITE_TIERS
    if (t <= 0) return it._origBorder
    if (t >= STACK_DEPTH) return tiers[STACK_DEPTH - 1]
    if (t <= 1) return lerpColor(it._origBorder, tiers[0], t)
    return lerpColor(tiers[0], tiers[1], t - 1)
  }

  const update = (progress) => {
    const pos = progress * (count - 1)
    columns.forEach((items) => {
      items.forEach((it, i) => {
        const rel = pos - i

        if (rel >= 1) {
          gsap.set(it, { autoAlpha: 0, zIndex: 1 })
          return
        }
        if (rel >= 0) {
          const scale = 1 + rel * (ACTIVE_SCALE_END - 1)
          const yPercent = rel * ACTIVE_Y_END
          let opacity = 1
          let blur = 0
          if (rel >= 0.66) {
            const t = (rel - 0.66) / 0.34
            opacity = 1 - t
            blur = t * 0.5
          }
          gsap.set(it, {
            scale,
            yPercent,
            autoAlpha: opacity,
            filter: `blur(${blur}rem)`,
            zIndex: 1000 - i,
            transformOrigin: 'top center',
            backgroundColor: toRgb(it._origBg),
            borderColor: toRgb(it._origBorder),
          })
          return
        }
        if (rel >= -STACK_DEPTH) {
          const t = -rel
          gsap.set(it, {
            scale: 1 - t * STACK_SCALE_STEP,
            y: t * STACK_OFFSET_PX,
            yPercent: 0,
            autoAlpha: 1,
            filter: 'blur(0rem)',
            zIndex: 1000 - i,
            transformOrigin: 'top center',
            backgroundColor: toRgb(tierColorAt(it, t)),
            borderColor: toRgb(tierBorderAt(it, t)),
          })
          return
        }
        gsap.set(it, { autoAlpha: 0, zIndex: 1 })
      })
    })
  }

  gsap.matchMedia().add('(max-width: 479px)', () => {
    const whyItems = section.querySelector('.why__items')
    if (!whyItems) return

    const existing = section.querySelector('.why__items-mobile')
    if (existing) existing.remove()

    const mobileWrap = document.createElement('div')
    mobileWrap.className = 'why__items-mobile'

    const pairCount = Math.min(...columns.map((col) => col.length))

    for (let i = 0; i < pairCount; i++) {
      const pair = document.createElement('div')
      pair.className = 'why-pair'

      lists.forEach((list, colIdx) => {
        const origColumn = list.closest('.why__column')
        const colClone = document.createElement('div')
        colClone.className = origColumn ? origColumn.className : 'why__column'

        const origWhyItems = list.closest('.why-items')
        const whyItemsClone = document.createElement('div')
        whyItemsClone.className = origWhyItems
          ? origWhyItems.className
          : 'why-items'

        const origHead = origWhyItems
          ? origWhyItems.querySelector('.why-items__head')
          : null
        if (origHead) whyItemsClone.appendChild(origHead.cloneNode(true))

        const listClone = document.createElement('div')
        listClone.className = list.className

        const itemClone = columns[colIdx][i].cloneNode(true)
        itemClone.removeAttribute('style')
        listClone.appendChild(itemClone)

        whyItemsClone.appendChild(listClone)
        colClone.appendChild(whyItemsClone)
        pair.appendChild(colClone)
      })

      mobileWrap.appendChild(pair)
    }

    whyItems.parentElement.insertBefore(mobileWrap, whyItems.nextSibling)
    whyItems.style.display = 'none'

    return () => {
      whyItems.style.display = ''
      if (mobileWrap.parentElement) {
        mobileWrap.parentElement.removeChild(mobileWrap)
      }
    }
  })

  gsap.matchMedia().add('(min-width: 480px)', () => {
    const CENTER_SCALE = 1.05

    let lastCenterIdx = -1
    let scaleRaf = null

    equalizeRowHeights()

    columns.forEach((items) => {
      items.forEach((it) => {
        gsap.set(it, { transformOrigin: 'center center' })
      })
    })

    const updateCenterScale = () => {
      scaleRaf = null
      const viewportCenter = window.innerHeight / 2
      const ref = columns[0]
      if (!ref || !ref.length) return

      let closestIdx = -1
      let closestDist = Infinity
      ref.forEach((it, i) => {
        const rect = it.getBoundingClientRect()
        const cy = rect.top + rect.height / 2
        const d = Math.abs(cy - viewportCenter)
        if (d < closestDist) {
          closestDist = d
          closestIdx = i
        }
      })

      const threshold = window.innerHeight * 0.4
      const activeIdx = closestDist < threshold ? closestIdx : -1

      if (activeIdx === lastCenterIdx) return
      lastCenterIdx = activeIdx

      columns.forEach((items) => {
        items.forEach((it, i) => {
          gsap.to(it, {
            scale: i === activeIdx ? CENTER_SCALE : 1,
            duration: 0.3,
            ease: 'power2.out',
            overwrite: 'auto',
          })
        })
      })
    }

    const onScroll = () => {
      if (scaleRaf) return
      scaleRaf = requestAnimationFrame(updateCenterScale)
    }
    window.addEventListener('scroll', onScroll, { passive: true })
    window.addEventListener('resize', onScroll)

    updateCenterScale()

    return () => {
      window.removeEventListener('scroll', onScroll)
      window.removeEventListener('resize', onScroll)
      if (scaleRaf) cancelAnimationFrame(scaleRaf)
      lastCenterIdx = -1
      columns.forEach((items) => {
        items.forEach((it) => {
          it.style.minHeight = ''
          gsap.set(it, {
            clearProps: 'transform,zIndex,backgroundColor,borderColor',
          })
        })
      })
    }
  })

  window.addEventListener('load', () => ScrollTrigger.refresh())
})

document.addEventListener('DOMContentLoaded', () => {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined')
    return
  gsap.registerPlugin(ScrollTrigger)

  const section = document.querySelector('.capabilities-section')
  if (!section) return

  const pinTarget =
    section.querySelector('.capabilities__in') ||
    section.querySelector('.capabilities__body')
  if (!pinTarget) return

  const controls = Array.from(section.querySelectorAll('.capabilities-control'))
  const items = Array.from(section.querySelectorAll('.capabilities-item'))
  if (!controls.length || !items.length) return

  const count = Math.min(controls.length, items.length)

  // Card stack like .the-platform-item: earlier cards scale down and peek above.
  // PEEK is the reserved space at the top they move into (overflow stays hidden,
  // so waiting cards don't spill out the bottom).
  const STEP_SCALE = 0.04
  const STEP_Y = 12
  const PEEK = (items.length - 1) * STEP_Y
  const GAP = 144 // gap (px) before the next card peeking in below

  const SVG_NS = 'http://www.w3.org/2000/svg'

  const decRects = controls.map((ctrl, idx) => {
    const svg = ctrl.querySelector('svg.capabilities-control__dec')
    if (!svg) return null
    const path = svg.querySelector('path')
    if (!path) return null

    const vb = (svg.getAttribute('viewBox') || '0 0 42 150')
      .split(/\s+/)
      .map(Number)
    const vbW = vb[2] || 42
    const vbH = vb[3] || 150

    let defs = svg.querySelector('defs')
    if (!defs) {
      defs = document.createElementNS(SVG_NS, 'defs')
      svg.insertBefore(defs, svg.firstChild)
    }

    const clipId = `capabilities-dec-clip-${idx}`
    const clip = document.createElementNS(SVG_NS, 'clipPath')
    clip.setAttribute('id', clipId)
    const rect = document.createElementNS(SVG_NS, 'rect')
    rect.setAttribute('x', '0')
    rect.setAttribute('y', '0')
    rect.setAttribute('width', String(vbW))
    rect.setAttribute('height', '0')
    clip.appendChild(rect)
    defs.appendChild(clip)

    const fill = path.cloneNode(true)
    fill.removeAttribute('id')
    fill.setAttribute('fill', '#1E5D2F')
    fill.setAttribute('clip-path', `url(#${clipId})`)
    fill.classList.add('capabilities-control__dec-fill')
    path.parentNode.appendChild(fill)

    return { rect, height: vbH }
  })

  const itemsWrap = items[0].parentElement

  const layout = () => {
    items.forEach((it) => {
      it.style.position = ''
      it.style.top = ''
      it.style.left = ''
      it.style.width = ''
      gsap.set(it, { clearProps: 'autoAlpha,yPercent,zIndex,scale,y,transformOrigin' })
    })
    itemsWrap.style.position = ''
    itemsWrap.style.minHeight = ''
    itemsWrap.style.overflow = ''
    const maxH = Math.max(...items.map((it) => it.offsetHeight))
    itemsWrap.style.position = 'relative'
    // +PEEK — top room for the peeking stacked cards
    itemsWrap.style.minHeight = `${maxH + PEEK}px`
    // visible so the next card peeks in below the current one
    itemsWrap.style.overflow = 'visible'
    items.forEach((it, i) => {
      it.style.position = 'absolute'
      it.style.top = '0'
      it.style.left = '0'
      it.style.width = '100%'
      gsap.set(it, {
        autoAlpha: 1,
        yPercent: i === 0 ? 0 : 100,
        zIndex: i,
        transformOrigin: 'top center',
        willChange: 'transform',
      })
    })
  }

  const setPosition = (pos, stackItems) => {
    const p = Math.max(0, Math.min(count - 1, pos))
    const activeIdx = Math.min(count - 1, Math.round(p))

    controls.forEach((c, i) => c.classList.toggle('is-active', i === activeIdx))
    if (stackItems) {
      const n = items.length
      const front = Math.floor(p) // current front card; front + 1 is the next
      // localT[i] — how far card i has arrived (0 below → 1 in place)
      const localT = items.map((it, i) =>
        i === 0 ? 1 : Math.max(0, Math.min(1, p - (i - 1))),
      )
      items.forEach((it, i) => {
        // steps — how many later cards already landed on top (stack depth)
        let steps = 0
        for (let j = i + 1; j < n; j++) steps += localT[j]
        gsap.set(it, {
          // only the stack + the single next card are visible; cards further
          // down stay hidden so they don't all overlap below
          autoAlpha: i <= front + 1 ? 1 : 0,
          yPercent: (1 - localT[i]) * 100, // slide in from below
          // move up into the reserved space; GAP keeps the next card spaced
          // below the current one while it's still peeking in
          y: PEEK - steps * STEP_Y + GAP * (1 - localT[i]),
          scale: 1 - steps * STEP_SCALE, // scale down by depth
        })
      })
    }
  }

  let activeTrigger = null
  let activeMode = null

  const scrollToItem = (i) => {
    if (!activeTrigger) {
      const target = items[i]
      if (!target) return
      const rect = target.getBoundingClientRect()
      window.scrollTo({
        top: window.scrollY + rect.top - window.innerHeight * 0.15,
        behavior: 'smooth',
      })
      return
    }
    let targetProgress
    if (activeMode === 'mobile') {
      targetProgress = (i + 0.5) / count
    } else {
      targetProgress = count > 1 ? i / (count - 1) : 0
    }
    const target =
      activeTrigger.start +
      targetProgress * (activeTrigger.end - activeTrigger.start)
    window.scrollTo({ top: target, behavior: 'smooth' })
  }

  controls.forEach((ctrl, i) => {
    ctrl.style.cursor = 'pointer'
    ctrl.addEventListener('click', () => scrollToItem(i))
  })

  gsap.matchMedia().add('(min-width: 480px)', () => {
    layout()
    setPosition(0, true)

    const st = ScrollTrigger.create({
      trigger: pinTarget,
      // pin higher than center so there's room below for the next card to peek in
      start: 'center 40%',
      end: `+=${(count - 1) * 200}%`,
      pin: true,
      pinSpacing: true,
      anticipatePin: 1, // smooths the little jump when the pin engages
      scrub: true,
      invalidateOnRefresh: true,
      onUpdate: (self) =>
        setPosition(self.progress * Math.max(1, count - 1), true),
      // re-apply positions right after layout so gaps/visibility are correct
      // immediately (even before the pin engages), not only once you scroll
      onRefresh: (self) => {
        layout()
        setPosition(self.progress * Math.max(1, count - 1), true)
      },
    })
    activeTrigger = st
    activeMode = 'desktop'

    return () => {
      st.kill()
      activeTrigger = null
      activeMode = null
      items.forEach((it) => {
        it.style.position = ''
        it.style.top = ''
        it.style.left = ''
        it.style.width = ''
        gsap.set(it, {
          clearProps: 'autoAlpha,yPercent,zIndex,scale,y,transformOrigin,willChange',
        })
      })
      itemsWrap.style.position = ''
      itemsWrap.style.minHeight = ''
      itemsWrap.style.overflow = ''
      controls.forEach((c) => c.classList.remove('is-active'))
      decRects.forEach((entry) => {
        if (entry) entry.rect.setAttribute('height', '0')
      })
    }
  })

  gsap.matchMedia().add('(max-width: 479px)', () => {
    setPosition(0, false)

    const st = ScrollTrigger.create({
      trigger: itemsWrap,
      start: 'top center',
      end: 'bottom center',
      scrub: true,
      invalidateOnRefresh: true,
      onUpdate: (self) => setPosition(self.progress * count - 0.5, false),
    })
    activeTrigger = st
    activeMode = 'mobile'

    return () => {
      st.kill()
      activeTrigger = null
      activeMode = null
      controls.forEach((c) => c.classList.remove('is-active'))
      decRects.forEach((entry) => {
        if (entry) entry.rect.setAttribute('height', '0')
      })
    }
  })

  window.addEventListener('load', () => ScrollTrigger.refresh())
})

document.addEventListener('DOMContentLoaded', () => {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined')
    return
  gsap.registerPlugin(ScrollTrigger)

  // All .cite blocks (Webflow often has separate desktop/mobile versions) —
  // previously only the first was used, so the mobile one wasn't animated.
  const cites = Array.from(document.querySelectorAll('.cite'))
  if (!cites.length) return

  const COLOR_DIM = 'rgba(30, 93, 47, 0.3)'
  const COLOR_FULL_R = 30
  const COLOR_FULL_G = 93
  const COLOR_FULL_B = 47

  const splitNode = (node, chars) => {
    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.nodeValue
      if (!text) return
      const frag = document.createDocumentFragment()
      for (const ch of text) {
        const sp = document.createElement('span')
        sp.className = 'cite__char'
        sp.textContent = ch
        sp.style.color = COLOR_DIM
        frag.appendChild(sp)
        if (ch !== ' ' && ch !== '\n' && ch !== '\t') chars.push(sp)
        else if (ch === ' ') chars.push(sp)
      }
      node.parentNode.replaceChild(frag, node)
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      Array.from(node.childNodes).forEach((n) => splitNode(n, chars))
    }
  }

  // Split each block into chars, keeping a per-block array.
  const blocks = []
  cites.forEach((cite) => {
    const content = cite.querySelector('.cite__content')
    if (!content) return
    const chars = []
    splitNode(content, chars)
    if (chars.length) blocks.push({ cite, chars })
  })
  if (!blocks.length) return

  const makeOnUpdate = (chars) => (self) => {
    const head = self.progress * chars.length
    for (let i = 0; i < chars.length; i++) {
      const local = Math.max(0, Math.min(1, head - i))
      const opacity = 0.3 + local * 0.7
      chars[i].style.color =
        `rgba(${COLOR_FULL_R}, ${COLOR_FULL_G}, ${COLOR_FULL_B}, ${opacity})`
    }
  }

  // Trigger only the block visible at this breakpoint
  // (offsetParent === null → display:none, skip it).
  const build = (start, end) => {
    const triggers = blocks
      .filter(({ cite }) => cite.offsetParent !== null)
      .map(({ cite, chars }) =>
        ScrollTrigger.create({
          trigger: cite,
          start,
          end,
          scrub: true,
          onUpdate: makeOnUpdate(chars),
        }),
      )
    return () => triggers.forEach((t) => t.kill())
  }

  gsap
    .matchMedia()
    .add('(min-width: 480px)', () => build('top 75%', 'bottom 60%'))
    // Mobile: start later (block already in the reading zone); finish when the
    // block top reaches the viewport top.
    .add('(max-width: 479px)', () => build('top 65%', 'top 0px'))

  // Recalc positions after full load (mobile layout shifts more), otherwise the
  // trigger range can be computed wrong.
  window.addEventListener('load', () => ScrollTrigger.refresh())
})

document.addEventListener('DOMContentLoaded', () => {
  const content = document.querySelector('[data-navigation-content]')
  const navList = document.querySelector('.navigation-sidebar__items')
  const navRoot = document.querySelector('.blog-post-content__navigation')

  const hideNav = () => {
    if (navRoot) navRoot.style.display = 'none'
    const blogContent = document.querySelector('.blog-post-content')
    if (blogContent) blogContent.classList.add('is-fw')
  }

  if (!navList) return
  if (!content) {
    hideNav()
    return
  }

  const headings = Array.from(content.querySelectorAll('h2, h3, h4'))
  if (!headings.length) {
    hideNav()
    return
  }

  navList.innerHTML = ''
  const items = headings.map((h, i) => {
    if (!h.id) h.id = `navigation-section-${i + 1}`
    const item = document.createElement('div')
    item.className = 'navigation-sidebar__item'
    item.style.cursor = 'pointer'
    item.dataset.target = h.id
    const inner = document.createElement('div')
    inner.className = 'body-sm color-primary'
    inner.textContent = h.textContent
    item.appendChild(inner)
    if (i === 0) item.classList.add('is-active')
    navList.appendChild(item)
    return item
  })

  const SCROLL_OFFSET = 30

  items.forEach((item, i) => {
    item.addEventListener('click', (e) => {
      e.preventDefault()
      const top =
        headings[i].getBoundingClientRect().top + window.scrollY - SCROLL_OFFSET
      window.scrollTo({ top, behavior: 'smooth' })
    })
  })

  let lastActiveIdx = -1
  const scrollNavToActive = (item) => {
    if (!navList) return
    if (navList.scrollHeight <= navList.clientHeight) return
    const itemTop = item.offsetTop
    const itemBottom = itemTop + item.offsetHeight
    const viewTop = navList.scrollTop
    const viewBottom = viewTop + navList.clientHeight
    const PAD = 16

    if (itemTop < viewTop + PAD) {
      navList.scrollTo({ top: Math.max(0, itemTop - PAD), behavior: 'smooth' })
    } else if (itemBottom > viewBottom - PAD) {
      navList.scrollTo({
        top: itemBottom - navList.clientHeight + PAD,
        behavior: 'smooth',
      })
    }
  }

  const updateActive = () => {
    const threshold = window.innerHeight * 0.4
    let activeIdx = 0
    for (let i = 0; i < headings.length; i++) {
      if (headings[i].getBoundingClientRect().top <= threshold) activeIdx = i
      else break
    }
    items.forEach((it, i) => it.classList.toggle('is-active', i === activeIdx))
    if (activeIdx !== lastActiveIdx) {
      lastActiveIdx = activeIdx
      scrollNavToActive(items[activeIdx])
    }
  }

  window.addEventListener('scroll', updateActive, { passive: true })
  window.addEventListener('resize', updateActive)
  window.addEventListener('load', updateActive)
  updateActive()
})

document.addEventListener('DOMContentLoaded', () => {
  const blogPost = document.querySelector('.blog-post')
  if (!blogPost) return
  if (!blogPost.querySelector('.blog-post__main-illustration')) {
    blogPost.classList.add('gap-0')
  }
})

document.addEventListener('DOMContentLoaded', () => {
  const richText = document.querySelector('.blog-post-content__rich-text')
  if (!richText) return

  const HOST = 'root-sustainability.com'
  const PATH_REWRITES = [
    { from: /^\/webinars\//, to: '/blogs/' },
    { from: /^\/press-release\//, to: '/blogs/' },
  ]

  const rewritePath = (pathname) => {
    for (const rule of PATH_REWRITES) {
      if (rule.from.test(pathname)) return pathname.replace(rule.from, rule.to)
    }
    return pathname
  }

  richText.querySelectorAll('a[href]').forEach((a) => {
    const href = a.getAttribute('href')
    if (!href) return
    try {
      const url = new URL(href, window.location.origin)
      const isOwnHost =
        url.hostname === HOST ||
        url.hostname === `www.${HOST}` ||
        url.hostname === window.location.hostname
      if (!isOwnHost) return
      const newPath = rewritePath(url.pathname)
      a.setAttribute('href', newPath + url.search + url.hash)
    } catch (e) {}
  })
})

document.addEventListener('DOMContentLoaded', () => {
  const customPagination = document.querySelector('.blog-list-pagination')
  if (!customPagination) return

  const hidePagination = () => {
    customPagination.style.display = 'none'
  }

  const wfWrapper = document.querySelector('.w-pagination-wrapper')
  if (!wfWrapper) {
    hidePagination()
    return
  }

  const wfLink = wfWrapper.querySelector('a[href*="_page"]')
  if (!wfLink) {
    hidePagination()
    return
  }

  let paramName = null
  try {
    const wfUrl = new URL(wfLink.getAttribute('href'), window.location.origin)
    paramName = Array.from(wfUrl.searchParams.keys()).find((k) =>
      k.endsWith('_page'),
    )
  } catch (e) {
    hidePagination()
    return
  }
  if (!paramName) {
    hidePagination()
    return
  }

  wfWrapper.style.display = 'none'

  const currentUrl = new URL(window.location.href)
  const currentPage =
    parseInt(currentUrl.searchParams.get(paramName) || '1', 10) || 1
  const hasNext = !!wfWrapper.querySelector('.w-pagination-next')
  const cacheKey = 'blog-total-pages-v2:' + window.location.pathname

  const buildUrl = (page) => {
    const u = new URL(window.location.href)
    if (page <= 1) u.searchParams.delete(paramName)
    else u.searchParams.set(paramName, String(page))
    return u.pathname + u.search + u.hash
  }

  const fetchPageDoc = async (page) => {
    try {
      const res = await fetch(buildUrl(page), { credentials: 'same-origin' })
      if (!res.ok) return null
      const text = await res.text()
      return new DOMParser().parseFromString(text, 'text/html')
    } catch (e) {
      return null
    }
  }

  const isValidPage = async (page) => {
    const doc = await fetchPageDoc(page)
    if (!doc) return false
    if (doc.querySelectorAll('.blog-list-item').length === 0) return false
    if (page === 1) return true
    const prev = doc.querySelector('.w-pagination-previous')
    if (!prev) return false
    try {
      const u = new URL(prev.getAttribute('href'), window.location.origin)
      const prevPage = parseInt(u.searchParams.get(paramName) || '0', 10) || 1
      return prevPage === page - 1
    } catch (e) {
      return false
    }
  }

  const findTotalPages = async () => {
    const cached = sessionStorage.getItem(cacheKey)
    if (cached) {
      const n = parseInt(cached, 10)
      if (n >= currentPage && n < 1000) return n
    }
    if (!hasNext) {
      sessionStorage.setItem(cacheKey, String(currentPage))
      return currentPage
    }

    let lower = currentPage
    let upper = Math.max(2, currentPage * 2)
    let safety = 8
    while (safety-- > 0 && (await isValidPage(upper))) {
      lower = upper
      upper *= 2
    }
    while (upper - lower > 1) {
      const mid = Math.floor((lower + upper) / 2)
      if (await isValidPage(mid)) lower = mid
      else upper = mid
    }

    sessionStorage.setItem(cacheKey, String(lower))
    return lower
  }

  const buildPageItems = (current, total) => {
    if (total <= 7) {
      return Array.from({ length: total }, (_, i) => i + 1)
    }
    const set = new Set([1, total, current, current - 1, current + 1])
    if (current <= 4) [2, 3, 4, 5].forEach((n) => set.add(n))
    if (current >= total - 3)
      [total - 1, total - 2, total - 3, total - 4].forEach((n) => set.add(n))
    const sorted = Array.from(set)
      .filter((n) => n >= 1 && n <= total)
      .sort((a, b) => a - b)
    const result = []
    for (let i = 0; i < sorted.length; i++) {
      result.push(sorted[i])
      if (i < sorted.length - 1 && sorted[i + 1] > sorted[i] + 1)
        result.push('...')
    }
    return result
  }

  const numbersWrap = customPagination.querySelector(
    '.blog-list-pagination__numbers',
  )

  const renderNumbers = (total) => {
    if (!numbersWrap) return
    numbersWrap.innerHTML = ''
    buildPageItems(currentPage, total).forEach((item) => {
      if (item === '...') {
        const el = document.createElement('span')
        el.className = 'blog-list-pagination__ellipsis'
        el.textContent = '…'
        numbersWrap.appendChild(el)
        return
      }
      const link = document.createElement('a')
      link.className = 'blog-list-pagination__number w-button'
      link.setAttribute('href', buildUrl(item))
      link.textContent = String(item)
      if (item === currentPage) link.classList.add('is-active')
      numbersWrap.appendChild(link)
    })
  }

  const renderControls = (total) => {
    Array.from(
      customPagination.querySelectorAll('.blog-list-pagination__control'),
    ).forEach((control) => {
      const isPrev = !!control.querySelector('.blog-list-pagination__prev')
      const isNext = !!control.querySelector('.blog-list-pagination__next')
      if (!isPrev && !isNext) return

      const target = isPrev ? currentPage - 1 : currentPage + 1
      const inRange = isPrev ? currentPage > 1 : currentPage < total

      if (inRange) {
        control.setAttribute('href', buildUrl(target))
        control.classList.remove('is-disabled')
        control.removeAttribute('aria-disabled')
      } else {
        control.removeAttribute('href')
        control.classList.add('is-disabled')
        control.setAttribute('aria-disabled', 'true')
      }
    })
  }

  const render = (total) => {
    if (total <= 1) {
      customPagination.style.display = 'none'
      return
    }
    customPagination.style.display = ''
    renderNumbers(total)
    renderControls(total)
  }

  // Optimistic initial render: show current page + 1 if Webflow says there's a Next
  const optimisticTotal = Math.max(
    currentPage,
    hasNext ? currentPage + 1 : currentPage,
  )
  render(optimisticTotal)

  findTotalPages()
    .then(render)
    .catch(() => {})
})

document.addEventListener('DOMContentLoaded', async () => {
  const tabs = document.querySelector('.blog-list__tabs')
  if (!tabs) return

  const categories = Array.from(tabs.querySelectorAll('.blog-list-category'))
  if (!categories.length) return

  const itemsContainer = document.querySelector('.blog-list__items')
  if (!itemsContainer) return

  const customPagination = document.querySelector('.blog-list-pagination')

  const getCategoryFromPost = (post) => {
    const link = post.querySelector('[data-category]')
    if (link) return (link.getAttribute('data-category') || '').trim()
    const label = post.querySelector('.blog-list-item__label .caption-xs')
    return label ? label.textContent.trim() : ''
  }

  const getCategoryName = (cat) => {
    const el = cat.querySelector('.caption-lg')
    return el ? el.textContent.trim() : ''
  }

  const setCounter = (cat, n) => {
    const counter = cat.querySelector(
      '.blog-list-category__counter .caption-xs',
    )
    if (counter) counter.textContent = String(n)
  }

  categories.forEach((c) => {
    c.style.cursor = 'pointer'
  })
  if (!categories.some((c) => c.classList.contains('is-active'))) {
    categories[0].classList.add('is-active')
  }

  const wfWrapper = document.querySelector('.w-pagination-wrapper')
  let paramName = null
  if (wfWrapper) {
    const wfLink = wfWrapper.querySelector('a[href*="_page"]')
    if (wfLink) {
      try {
        const wfUrl = new URL(
          wfLink.getAttribute('href'),
          window.location.origin,
        )
        paramName = Array.from(wfUrl.searchParams.keys()).find((k) =>
          k.endsWith('_page'),
        )
      } catch (e) {}
    }
  }

  const buildPageUrl = (page) => {
    const u = new URL(window.location.href)
    if (!paramName || page <= 1) {
      if (paramName) u.searchParams.delete(paramName)
    } else {
      u.searchParams.set(paramName, String(page))
    }
    return u.pathname + u.search + u.hash
  }

  const fetchPageDoc = async (page) => {
    try {
      const res = await fetch(buildPageUrl(page), {
        credentials: 'same-origin',
      })
      if (!res.ok) return null
      const text = await res.text()
      return new DOMParser().parseFromString(text, 'text/html')
    } catch (e) {
      return null
    }
  }

  const originalItemsHTML = itemsContainer.innerHTML
  const currentPagePosts = Array.from(
    itemsContainer.querySelectorAll('.blog-list-item'),
  )

  const isValidPageDoc = (doc, page) => {
    if (!doc) return false
    if (doc.querySelectorAll('.blog-list-item').length === 0) return false
    if (page === 1) return true
    const prev = doc.querySelector('.w-pagination-previous')
    if (!prev) return false
    try {
      const u = new URL(prev.getAttribute('href'), window.location.origin)
      const prevPage = parseInt(u.searchParams.get(paramName) || '0', 10) || 1
      return prevPage === page - 1
    } catch (e) {
      return false
    }
  }

  const aggregateAllPosts = async () => {
    if (!paramName) return [...currentPagePosts]

    const currentPage =
      parseInt(
        new URL(window.location.href).searchParams.get(paramName) || '1',
        10,
      ) || 1
    const cacheKey = 'blog-total-pages-v2:' + window.location.pathname
    let totalPages = parseInt(sessionStorage.getItem(cacheKey) || '0', 10)
    if (totalPages >= 1000) totalPages = 0

    const posts = []
    if (totalPages > 0) {
      for (let p = 1; p <= totalPages; p++) {
        if (p === currentPage) {
          posts.push(...currentPagePosts)
        } else {
          const doc = await fetchPageDoc(p)
          if (!doc) continue
          posts.push(...Array.from(doc.querySelectorAll('.blog-list-item')))
        }
      }
    } else {
      let p = 1
      const SAFETY = 100
      while (p <= SAFETY) {
        let items
        if (p === currentPage) {
          items = currentPagePosts
        } else {
          const doc = await fetchPageDoc(p)
          if (!isValidPageDoc(doc, p)) break
          items = Array.from(doc.querySelectorAll('.blog-list-item'))
        }
        posts.push(...items)
        p++
      }
      sessionStorage.setItem(cacheKey, String(Math.max(1, p - 1)))
    }
    return posts
  }

  let allPosts = []
  try {
    allPosts = await aggregateAllPosts()
  } catch (e) {
    allPosts = [...currentPagePosts]
  }

  const counts = {}
  allPosts.forEach((post) => {
    const cat = getCategoryFromPost(post)
    if (cat) counts[cat] = (counts[cat] || 0) + 1
  })

  categories.forEach((cat, idx) => {
    const name = getCategoryName(cat)
    const count = idx === 0 ? allPosts.length : counts[name] || 0
    setCounter(cat, count)
    if (count === 0) {
      cat.style.display = 'none'
    } else {
      cat.style.display = ''
    }
  })

  categories.forEach((cat, idx) => {
    cat.addEventListener('click', (e) => {
      e.preventDefault()
      categories.forEach((c) => c.classList.remove('is-active'))
      cat.classList.add('is-active')

      if (idx === 0) {
        if (paramName) {
          const currentUrlNow = new URL(window.location.href)
          if (currentUrlNow.searchParams.get(paramName)) {
            window.location.href = buildPageUrl(1)
            return
          }
        }
        itemsContainer.innerHTML = originalItemsHTML
        if (customPagination) customPagination.style.display = ''
        return
      }

      const name = getCategoryName(cat)
      const filtered = allPosts.filter((p) => getCategoryFromPost(p) === name)
      itemsContainer.innerHTML = ''
      filtered.forEach((p) => itemsContainer.appendChild(p.cloneNode(true)))
      if (customPagination) customPagination.style.display = 'none'
    })
  })

  const slugify = (str) =>
    (str || '')
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '')

  const filterParam = new URL(window.location.href).searchParams.get('filter')
  if (filterParam) {
    const target = slugify(filterParam)
    const match = categories.find(
      (cat) => slugify(getCategoryName(cat)) === target,
    )
    if (match) match.click()
  }
})

document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.socials__item')
  if (!items.length) return

  const buildShareUrl = (item) => {
    const url = encodeURIComponent(window.location.href)
    const title = encodeURIComponent(document.title)
    if (item.classList.contains('socials__item--linkedin')) {
      return `https://www.linkedin.com/sharing/share-offsite/?url=${url}`
    }
    if (item.classList.contains('socials__item--x')) {
      return `https://twitter.com/intent/tweet?url=${url}&text=${title}`
    }
    if (item.classList.contains('socials__item--facebook')) {
      return `https://www.facebook.com/sharer/sharer.php?u=${url}`
    }
    return null
  }

  items.forEach((item) => {
    const href = buildShareUrl(item)
    if (!href) return
    item.setAttribute('href', href)
    item.setAttribute('target', '_blank')
    item.setAttribute('rel', 'noopener noreferrer')
    item.addEventListener('click', (e) => {
      e.preventDefault()
      const w = 600
      const h = 500
      const left = Math.round((window.screen.width - w) / 2)
      const top = Math.round((window.screen.height - h) / 2)
      window.open(
        href,
        'share-window',
        `width=${w},height=${h},left=${left},top=${top}`,
      )
    })
  })
})

document.addEventListener('DOMContentLoaded', () => {
  const bodies = document.querySelectorAll('.blog-custom-blocks-item__body')
  if (!bodies.length) return

  const ICON_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>'

  const copyToClipboard = async (text) => {
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text)
        return true
      } catch (e) {}
    }
    const ta = document.createElement('textarea')
    ta.value = text
    ta.style.position = 'fixed'
    ta.style.left = '-9999px'
    document.body.appendChild(ta)
    ta.select()
    let ok = false
    try {
      ok = document.execCommand('copy')
    } catch (e) {}
    ta.remove()
    return ok
  }

  bodies.forEach((body) => {
    const btn = document.createElement('button')
    btn.type = 'button'
    btn.className = 'blog-custom-blocks-item__copy'
    btn.setAttribute('aria-label', 'Copy block HTML')
    btn.innerHTML = ICON_SVG
    body.appendChild(btn)

    btn.addEventListener('click', async (e) => {
      e.preventDefault()
      const clone = body.cloneNode(true)
      const innerBtn = clone.querySelector('.blog-custom-blocks-item__copy')
      if (innerBtn) innerBtn.remove()
      const html = clone.innerHTML.trim()

      const ok = await copyToClipboard(html)
      btn.classList.toggle('is-copied', ok)
      btn.classList.toggle('is-failed', !ok)
      setTimeout(() => {
        btn.classList.remove('is-copied')
        btn.classList.remove('is-failed')
      }, 1500)
    })
  })
})

document.addEventListener('DOMContentLoaded', () => {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined')
    return
  gsap.registerPlugin(ScrollTrigger)

  const wrapper = document.querySelector('.how-solves__wrapper')
  if (!wrapper) return

  const controls = Array.from(
    wrapper.querySelectorAll('.how-solves-controls-item'),
  )
  const items = Array.from(wrapper.querySelectorAll('.how-solves-item'))
  if (!controls.length || !items.length) return

  const count = Math.min(controls.length, items.length)
  const itemsWrap = items[0].parentElement

  const layout = () => {
    items.forEach((it) => {
      it.style.position = ''
      it.style.top = ''
      it.style.left = ''
      it.style.width = ''
      it.style.minHeight = ''
      gsap.set(it, { clearProps: 'autoAlpha' })
    })
    itemsWrap.style.position = ''
    itemsWrap.style.minHeight = ''
    const maxH = Math.max(...items.map((it) => it.offsetHeight))
    itemsWrap.style.position = 'relative'
    itemsWrap.style.minHeight = `${maxH}px`
    items.forEach((it, i) => {
      it.style.position = 'absolute'
      it.style.top = '0'
      it.style.left = '0'
      it.style.width = '100%'
      it.style.minHeight = `${maxH}px`
      gsap.set(it, { autoAlpha: i === 0 ? 1 : 0 })
    })
  }

  const setPosition = (pos) => {
    const p = Math.max(0, Math.min(count - 1, pos))
    const activeIdx = Math.min(count - 1, Math.floor(p + 1e-6))
    controls.forEach((c, i) => c.classList.toggle('is-active', i === activeIdx))
    items.forEach((it, i) =>
      gsap.set(it, { autoAlpha: i === activeIdx ? 1 : 0 }),
    )
  }

  let activeTrigger = null

  const scrollToItem = (i) => {
    if (!activeTrigger) return
    const targetProgress = count > 1 ? i / (count - 1) : 0
    const target =
      activeTrigger.start +
      targetProgress * (activeTrigger.end - activeTrigger.start)
    window.scrollTo({ top: target, behavior: 'smooth' })
  }

  controls.forEach((ctrl, i) => {
    ctrl.style.cursor = 'pointer'
    ctrl.addEventListener('click', () => scrollToItem(i))
  })

  gsap.matchMedia().add('(min-width: 480px)', () => {
    layout()
    setPosition(0)

    const st = ScrollTrigger.create({
      trigger: wrapper,
      start: 'center center',
      end: `+=${(count - 1) * 80}%`,
      pin: true,
      pinSpacing: true,
      scrub: true,
      invalidateOnRefresh: true,
      onUpdate: (self) => setPosition(self.progress * Math.max(1, count - 1)),
      onRefresh: () => layout(),
    })
    activeTrigger = st

    return () => {
      st.kill()
      activeTrigger = null
      items.forEach((it) => {
        it.style.position = ''
        it.style.top = ''
        it.style.left = ''
        it.style.width = ''
        it.style.minHeight = ''
        gsap.set(it, { clearProps: 'autoAlpha' })
      })
      itemsWrap.style.position = ''
      itemsWrap.style.minHeight = ''
      controls.forEach((c) => c.classList.remove('is-active'))
    }
  })

  window.addEventListener('load', () => ScrollTrigger.refresh())
})

document.addEventListener('DOMContentLoaded', () => {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined')
    return
  if (window.matchMedia('(max-width: 479px)').matches) return
  gsap.registerPlugin(ScrollTrigger)

  const items = document.querySelectorAll('.we-started-item')
  if (!items.length) return

  const finalRotates = [-2, 0]

  items.forEach((item, i) => {
    const finalRotate = finalRotates[i] != null ? finalRotates[i] : 0
    const startTilt = finalRotate + (i % 2 === 0 ? -4 : 4)
    const yOffset = 32

    gsap.set(item, {
      transformOrigin: 'center center',
      willChange: 'transform',
    })

    gsap.fromTo(
      item,
      { rotate: startTilt, y: yOffset },
      {
        rotate: finalRotate,
        y: 0,
        ease: 'none',
        scrollTrigger: {
          trigger: item,
          start: 'top 90%',
          end: 'center 65%',
          scrub: 1,
        },
      },
    )
  })

  window.addEventListener('load', () => ScrollTrigger.refresh())
})

document.addEventListener('DOMContentLoaded', () => {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined')
    return
  gsap.registerPlugin(ScrollTrigger)

  const body = document.querySelector('.why-retailers__body')
  if (!body) return

  const columns = Array.from(body.querySelectorAll('.why-retailers__column'))
  if (columns.length && !window.matchMedia('(max-width: 479px)').matches) {
    gsap.fromTo(
      columns,
      { autoAlpha: 0, y: 24 },
      {
        autoAlpha: 1,
        y: 0,
        duration: 0.7,
        stagger: 0.2,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: body,
          start: 'top 80%',
          once: true,
        },
      },
    )
  }

  const supplyBody = body.querySelector('.why-retailers-supply__body')
  if (supplyBody && !window.matchMedia('(max-width: 479px)').matches) {
    const tierItems = supplyBody.querySelectorAll('.why-retailers-supply-item')
    if (tierItems.length) {
      gsap.fromTo(
        tierItems,
        { autoAlpha: 0, y: 12 },
        {
          autoAlpha: 1,
          y: 0,
          duration: 0.5,
          stagger: 0.18,
          ease: 'power2.out',
          delay: 0.3,
          scrollTrigger: {
            trigger: supplyBody,
            start: 'top 80%',
            once: true,
          },
        },
      )
    }
  }

  const graphic = body.querySelector('.why-retailers-graphic')
  const svg = graphic && graphic.querySelector('.why-retailers__svg')
  if (svg && svg.tagName.toLowerCase() === 'svg') {
    const mainPath = svg.querySelector('path:not([opacity])')
    if (mainPath) {
      const SVG_NS = 'http://www.w3.org/2000/svg'
      const maskId = 'why-retailers-chart-mask'

      let defs = svg.querySelector('defs')
      if (!defs) {
        defs = document.createElementNS(SVG_NS, 'defs')
        svg.insertBefore(defs, svg.firstChild)
      }

      const oldClip = defs.querySelector('#why-retailers-chart-clip')
      if (oldClip) oldClip.remove()
      mainPath.removeAttribute('clip-path')

      const mask = document.createElementNS(SVG_NS, 'mask')
      mask.setAttribute('id', maskId)
      mask.setAttribute('maskUnits', 'userSpaceOnUse')
      mask.setAttribute('x', '0')
      mask.setAttribute('y', '0')
      mask.setAttribute('width', '290')
      mask.setAttribute('height', '290')

      const r = 125
      const circumference = 2 * Math.PI * r
      const circle = document.createElementNS(SVG_NS, 'circle')
      circle.setAttribute('cx', '145')
      circle.setAttribute('cy', '145')
      circle.setAttribute('r', String(r))
      circle.setAttribute('fill', 'none')
      circle.setAttribute('stroke', '#fff')
      circle.setAttribute('stroke-width', '60')
      circle.setAttribute('transform', 'rotate(-90 145 145)')
      circle.setAttribute('stroke-dasharray', String(circumference))
      circle.setAttribute('stroke-dashoffset', String(circumference))

      mask.appendChild(circle)
      defs.appendChild(mask)
      mainPath.setAttribute('mask', `url(#${maskId})`)

      gsap.to(circle, {
        attr: { 'stroke-dashoffset': circumference * 0.1 },
        duration: 1.6,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: graphic,
          start: 'top 75%',
          once: true,
        },
      })
    }
  }

  const logosWrap = body.querySelector('.why-retailers-build__logos')
  if (logosWrap) {
    logosWrap.innerHTML += logosWrap.innerHTML
    const imgs = logosWrap.querySelectorAll('img')
    imgs.forEach((img) => {
      img.loading = 'eager'
      img.decoding = 'async'
    })
    let loaded = 0
    let marqueeTween = null
    let started = false
    const speed = 35

    const startMarquee = () => {
      if (marqueeTween) {
        marqueeTween.kill()
        gsap.set(logosWrap, { clearProps: 'x,y' })
      }
      const isMobile = window.matchMedia('(max-width: 479px)').matches
      const distance = isMobile
        ? logosWrap.scrollWidth / 2
        : logosWrap.scrollHeight / 2
      if (!distance) return
      started = true
      marqueeTween = gsap.fromTo(logosWrap, isMobile ? { x: 0 } : { y: 0 }, {
        [isMobile ? 'x' : 'y']: -distance,
        duration: distance / speed,
        ease: 'none',
        repeat: -1,
      })
    }

    const tryStart = () => {
      if (!started) startMarquee()
    }

    if (imgs.length === 0) {
      startMarquee()
    } else {
      imgs.forEach((img) => {
        if (img.complete && img.naturalWidth > 0) {
          if (++loaded === imgs.length) startMarquee()
        } else {
          const onDone = () => {
            if (++loaded === imgs.length) tryStart()
          }
          img.addEventListener('load', onDone, { once: true })
          img.addEventListener('error', onDone, { once: true })
        }
      })
      setTimeout(tryStart, 1500)
      window.addEventListener('load', tryStart, { once: true })
    }

    let resizeTimer = null
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer)
      resizeTimer = setTimeout(startMarquee, 200)
    })
  }
})

document.addEventListener('DOMContentLoaded', () => {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined')
    return
  if (window.matchMedia('(max-width: 479px)').matches) return
  gsap.registerPlugin(ScrollTrigger)

  const section = document.querySelector('.how-it-works__body')
  if (!section) return

  const wrappers = Array.from(
    section.querySelectorAll('.how-it-works-item-wrapper'),
  )
  if (!wrappers.length) return

  const stage = section.querySelector(
    '.how-it-works__screenshots .how-it-works__screenshot',
  )
  if (!stage) return

  // Prevent Webflow from reprocessing
  stage.removeAttribute('data-animation-type')
  stage.removeAttribute('data-w-id')

  const ensureLottie = () => {
    if (window.lottie || window.bodymovin)
      return Promise.resolve(window.lottie || window.bodymovin)
    return new Promise((resolve, reject) => {
      const existing = document.querySelector('script[data-lottie-loader]')
      if (existing) {
        existing.addEventListener('load', () =>
          resolve(window.lottie || window.bodymovin),
        )
        existing.addEventListener('error', () =>
          reject(new Error('lottie failed')),
        )
        return
      }
      const s = document.createElement('script')
      s.src =
        'https://cdnjs.cloudflare.com/ajax/libs/bodymovin/5.12.2/lottie.min.js'
      s.async = true
      s.setAttribute('data-lottie-loader', '')
      s.onload = () => resolve(window.lottie || window.bodymovin)
      s.onerror = () => reject(new Error('lottie failed'))
      document.head.appendChild(s)
    })
  }

  let currentSrc = null
  let currentAnim = null

  gsap.set(stage, { transformOrigin: 'center center', scale: 1 })

  const replaceLottie = (lottieLib, src) => {
    if (currentAnim) {
      try {
        currentAnim.destroy()
      } catch (e) {}
      currentAnim = null
    }
    stage.innerHTML = ''
    try {
      currentAnim = lottieLib.loadAnimation({
        container: stage,
        renderer: stage.getAttribute('data-renderer') || 'svg',
        loop: stage.getAttribute('data-loop') !== '0',
        autoplay: stage.getAttribute('data-autoplay') !== '0',
        path: src,
      })
    } catch (e) {
      console.error('lottie load failed', e)
    }
  }

  const swap = (lottieLib, src) => {
    if (!src || src === currentSrc) return
    const isFirst = currentSrc === null
    currentSrc = src

    if (isFirst) {
      replaceLottie(lottieLib, src)
      return
    }

    gsap.killTweensOf(stage)
    gsap.to(stage, {
      scale: 0,
      duration: 0.35,
      ease: 'power2.in',
      onComplete: () => {
        replaceLottie(lottieLib, src)
        gsap.to(stage, {
          scale: 1,
          duration: 0.45,
          ease: 'back.out(1.3)',
        })
      },
    })
  }

  ensureLottie()
    .then((lottieLib) => {
      if (!lottieLib) return
      const initialSrc = wrappers[0].getAttribute('data-lottie-animation')
      if (initialSrc) swap(lottieLib, initialSrc)
      wrappers.forEach((wrapper) => {
        const src = wrapper.getAttribute('data-lottie-animation')
        if (!src) return
        ScrollTrigger.create({
          trigger: wrapper,
          start: 'top center',
          end: 'bottom center',
          onEnter: () => swap(lottieLib, src),
          onEnterBack: () => swap(lottieLib, src),
        })
      })
    })
    .catch(() => {})
})

document.addEventListener('DOMContentLoaded', () => {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined')
    return
  if (window.matchMedia('(max-width: 479px)').matches) return
  gsap.registerPlugin(ScrollTrigger)

  const section = document.querySelector('.how-it-works__body')
  if (!section) return

  const items = Array.from(
    section.querySelectorAll('.how-it-works-item-wrapper'),
  )
  if (items.length < 2) return

  const wrapper = section.querySelector('.how-it-works__screenshot-wrapper')
  if (!wrapper) return

  let wrapperCenterNatural = 0
  let firstCenter = 0
  let lastCenter = 0

  const measure = () => {
    gsap.set(wrapper, { y: 0 })
    const wRect = wrapper.getBoundingClientRect()
    wrapperCenterNatural = wRect.top + window.scrollY + wRect.height / 2
    const fRect = items[0].getBoundingClientRect()
    firstCenter = fRect.top + window.scrollY + fRect.height / 2
    const lRect = items[items.length - 1].getBoundingClientRect()
    lastCenter = lRect.top + window.scrollY + lRect.height / 2
  }

  measure()

  gsap.fromTo(
    wrapper,
    { y: () => firstCenter - wrapperCenterNatural },
    {
      y: () => lastCenter - wrapperCenterNatural,
      ease: 'none',
      scrollTrigger: {
        trigger: items[0],
        start: 'center center',
        endTrigger: items[items.length - 1],
        end: 'center center',
        scrub: 1.2,
        invalidateOnRefresh: true,
        onRefreshInit: () => measure(),
      },
    },
  )

  window.addEventListener('load', () => {
    ScrollTrigger.refresh()
  })
})

document.addEventListener('DOMContentLoaded', () => {
  if (!window.matchMedia('(max-width: 479px)').matches) return

  const header = document.querySelector('.header')
  if (!header) return

  let lastY = window.scrollY
  let ticking = false
  let isHidden = false
  const DELTA_THRESHOLD = 5

  const updateHeader = () => {
    const currentY = window.scrollY
    const delta = currentY - lastY

    if (Math.abs(delta) < DELTA_THRESHOLD) {
      ticking = false
      return
    }

    const pastFirstScreen = currentY > window.innerHeight

    if (delta > 0 && pastFirstScreen) {
      if (!isHidden) {
        header.classList.add('is-hide')
        isHidden = true
      }
    } else if (delta < 0) {
      if (isHidden) {
        header.classList.remove('is-hide')
        isHidden = false
      }
    }

    if (currentY <= 0 && isHidden) {
      header.classList.remove('is-hide')
      isHidden = false
    }

    lastY = currentY
    ticking = false
  }

  const onScroll = () => {
    if (!ticking) {
      ticking = true
      requestAnimationFrame(updateHeader)
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true })
})

document.addEventListener('DOMContentLoaded', () => {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined')
    return
  if (window.matchMedia('(max-width: 479px)').matches) return
  gsap.registerPlugin(ScrollTrigger)

  const items = document.querySelectorAll('.the-problem-item')
  if (!items.length) return

  const getBaseRotate = (el) => {
    const t = window.getComputedStyle(el).transform
    if (!t || t === 'none') return 0
    const m = new DOMMatrix(t)
    return Math.atan2(m.b, m.a) * (180 / Math.PI)
  }

  items.forEach((item, i) => {
    const baseRotate = getBaseRotate(item)
    const sign = i % 2 === 0 ? -1 : 1
    const startTilt = baseRotate + sign * 4
    const yOffset = 32

    gsap.set(item, {
      transformOrigin: 'center center',
      willChange: 'transform',
    })

    gsap.fromTo(
      item,
      { rotate: startTilt, y: yOffset },
      {
        rotate: baseRotate,
        y: 0,
        ease: 'none',
        scrollTrigger: {
          trigger: item,
          start: 'top 90%',
          end: 'center 65%',
          scrub: 1,
        },
      },
    )
  })
})

document.addEventListener('DOMContentLoaded', () => {
  if (typeof gsap === 'undefined') return
  if (!window.matchMedia('(max-width: 479px)').matches) return

  const poster = document.querySelector('.intro__poster.mobile-visible')
  if (!poster) return

  poster.style.willChange = 'opacity'
  gsap.set(poster, { autoAlpha: 0, force3D: true })

  const hasSvg = () => poster.querySelector('svg') !== null

  let revealed = false
  const reveal = () => {
    if (revealed) return
    revealed = true
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        gsap.to(poster, {
          autoAlpha: 1,
          duration: 1.4,
          ease: 'sine.out',
          onComplete: () => {
            poster.style.willChange = ''
          },
        })
      })
    })
  }

  if (hasSvg()) {
    reveal()
    return
  }

  const observer = new MutationObserver(() => {
    if (hasSvg()) {
      observer.disconnect()
      reveal()
    }
  })
  observer.observe(poster, { childList: true, subtree: true })

  setTimeout(() => {
    observer.disconnect()
    reveal()
  }, 8000)
})

document.addEventListener('DOMContentLoaded', () => {
  if (typeof gsap === 'undefined') return

  const poster = document.querySelector('.intro__poster.mobile-hidden')
  if (!poster) return

  const src = poster.getAttribute('data-src')

  poster.style.willChange = 'opacity'
  gsap.set(poster, { autoAlpha: 0, force3D: true })

  let revealed = false
  const reveal = () => {
    if (revealed) return
    revealed = true
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        gsap.to(poster, {
          autoAlpha: 1,
          duration: 1.4,
          ease: 'sine.out',
          onComplete: () => {
            poster.style.willChange = ''
          },
        })
      })
    })
  }

  const hasSvg = () => poster.querySelector('svg') !== null

  poster.removeAttribute('data-animation-type')
  poster.removeAttribute('data-w-id')
  poster.removeAttribute('data-loading')

  if (hasSvg()) {
    reveal()
    return
  }

  if (!src) {
    reveal()
    return
  }

  const ensureLottie = () => {
    if (window.lottie || window.bodymovin)
      return Promise.resolve(window.lottie || window.bodymovin)
    return new Promise((resolve, reject) => {
      const existing = document.querySelector('script[data-lottie-loader]')
      if (existing) {
        existing.addEventListener('load', () =>
          resolve(window.lottie || window.bodymovin),
        )
        existing.addEventListener('error', () =>
          reject(new Error('lottie failed')),
        )
        return
      }
      const s = document.createElement('script')
      s.src =
        'https://cdnjs.cloudflare.com/ajax/libs/bodymovin/5.12.2/lottie.min.js'
      s.async = true
      s.setAttribute('data-lottie-loader', '')
      s.onload = () => resolve(window.lottie || window.bodymovin)
      s.onerror = () => reject(new Error('lottie failed'))
      document.head.appendChild(s)
    })
  }

  const dataPromise = fetch(src, { credentials: 'omit', cache: 'force-cache' })
    .then((r) => (r.ok ? r.json() : null))
    .catch(() => null)

  Promise.all([ensureLottie(), dataPromise])
    .then(([lottieLib, data]) => {
      if (!lottieLib) {
        reveal()
        return
      }
      poster.innerHTML = ''
      try {
        const opts = {
          container: poster,
          renderer: poster.getAttribute('data-renderer') || 'svg',
          loop: poster.getAttribute('data-loop') !== '0',
          autoplay: poster.getAttribute('data-autoplay') !== '0',
        }
        if (data) opts.animationData = data
        else opts.path = src
        const anim = lottieLib.loadAnimation(opts)
        anim.addEventListener('DOMLoaded', reveal)
      } catch (e) {
        console.error('intro poster lottie load failed', e)
      }
      setTimeout(reveal, 2500)
    })
    .catch(() => reveal())
})

document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.contact-us-item')
  if (!items.length) return

  const POPUP_DURATION = 5000

  const copyToClipboard = (text) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).catch(() => fallbackCopy(text))
    }
    return fallbackCopy(text)
  }

  const fallbackCopy = (text) => {
    return new Promise((resolve) => {
      const ta = document.createElement('textarea')
      ta.value = text
      ta.setAttribute('readonly', '')
      ta.style.position = 'fixed'
      ta.style.top = '0'
      ta.style.left = '0'
      ta.style.opacity = '0'
      document.body.appendChild(ta)
      ta.select()
      try {
        document.execCommand('copy')
      } catch (e) {}
      document.body.removeChild(ta)
      resolve()
    })
  }

  const getCopyValue = (item) => {
    const href = item.getAttribute('href') || ''
    if (href.startsWith('mailto:')) return href.replace(/^mailto:/, '').trim()
    if (href.startsWith('tel:')) {
      const text = item.querySelector('.contact-us-item__text .body-sm')
      return text ? text.textContent.trim() : href.replace(/^tel:/, '').trim()
    }
    return null
  }

  items.forEach((item) => {
    const popup = item.querySelector('.contact-item-popup')
    if (!popup) return

    const value = getCopyValue(item)
    if (!value) return

    let timer = null

    item.addEventListener('click', (e) => {
      e.preventDefault()
      copyToClipboard(value)
      popup.classList.add('is-active')
      if (timer) clearTimeout(timer)
      timer = setTimeout(() => {
        popup.classList.remove('is-active')
        timer = null
      }, POPUP_DURATION)
    })
  })
})

document.addEventListener('DOMContentLoaded', () => {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined')
    return
  if (!window.matchMedia('(max-width: 479px)').matches) return
  gsap.registerPlugin(ScrollTrigger)

  const sectionEl = document.querySelector('.how-it-works-section')
  const body = document.querySelector('.how-it-works__body')
  if (!sectionEl || !body) return

  const itemsWrap = body.querySelector('.how-it-works__items')
  if (!itemsWrap) return

  const wrappers = Array.from(
    itemsWrap.querySelectorAll('.how-it-works-item-wrapper'),
  )
  if (wrappers.length < 2) return

  const animationBlock = body.querySelector('.how-it-works__animation')
  const pageCount = wrappers.length

  body.style.position = 'relative'
  body.style.overflow = 'hidden'
  body.style.width = '100vw'
  body.style.maxWidth = '100vw'
  body.style.marginLeft = 'calc(50% - 50vw)'
  body.style.marginRight = 'calc(50% - 50vw)'

  itemsWrap.style.display = 'flex'
  itemsWrap.style.flexDirection = 'row'
  itemsWrap.style.flexWrap = 'nowrap'
  itemsWrap.style.alignItems = 'flex-start'
  itemsWrap.style.willChange = 'transform'

  wrappers.forEach((w) => {
    w.style.flex = '0 0 100vw'
    w.style.width = '100vw'
    w.style.maxWidth = '100vw'
    w.style.height = 'auto'
    w.style.boxSizing = 'border-box'
  })

  if (animationBlock) {
    animationBlock.style.width = `${pageCount * 100}vw`
    animationBlock.style.maxWidth = 'none'
    animationBlock.style.marginTop = '0'
    animationBlock.style.marginLeft = '0'
    animationBlock.style.marginRight = '0'
    animationBlock.style.willChange = 'transform'
  }

  const items = wrappers
    .map((w) => w.querySelector('.how-it-works-item'))
    .filter(Boolean)

  const measureMaxHeight = () => {
    items.forEach((it) => (it.style.minHeight = ''))
    if (!items.length) return 0
    const max = Math.max(...items.map((it) => it.offsetHeight))
    items.forEach((it) => (it.style.minHeight = `${max}px`))
    return max
  }

  measureMaxHeight()

  const stage = body.querySelector(
    '.how-it-works__screenshots .how-it-works__screenshot',
  )

  const ensureLottie = () => {
    if (window.lottie || window.bodymovin)
      return Promise.resolve(window.lottie || window.bodymovin)
    return new Promise((resolve, reject) => {
      const existing = document.querySelector('script[data-lottie-loader]')
      if (existing) {
        existing.addEventListener('load', () =>
          resolve(window.lottie || window.bodymovin),
        )
        existing.addEventListener('error', () =>
          reject(new Error('lottie failed')),
        )
        return
      }
      const s = document.createElement('script')
      s.src =
        'https://cdnjs.cloudflare.com/ajax/libs/bodymovin/5.12.2/lottie.min.js'
      s.async = true
      s.setAttribute('data-lottie-loader', '')
      s.onload = () => resolve(window.lottie || window.bodymovin)
      s.onerror = () => reject(new Error('lottie failed'))
      document.head.appendChild(s)
    })
  }

  let lottieLib = null
  let currentSrc = null
  let currentAnim = null

  const replaceLottie = (src) => {
    if (!stage || !lottieLib) return
    if (currentAnim) {
      try {
        currentAnim.destroy()
      } catch (e) {}
      currentAnim = null
    }
    stage.innerHTML = ''
    try {
      currentAnim = lottieLib.loadAnimation({
        container: stage,
        renderer: stage.getAttribute('data-renderer') || 'svg',
        loop: stage.getAttribute('data-loop') !== '0',
        autoplay: stage.getAttribute('data-autoplay') !== '0',
        path: src,
      })
    } catch (e) {}
  }

  const swap = (src) => {
    if (!src || src === currentSrc) return
    currentSrc = src
    replaceLottie(src)
  }

  if (stage) {
    stage.removeAttribute('data-animation-type')
    stage.removeAttribute('data-w-id')
    ensureLottie()
      .then((lib) => {
        lottieLib = lib
        const initial = wrappers[0].getAttribute('data-lottie-animation')
        if (initial) swap(initial)
      })
      .catch(() => {})
  }

  let lastActive = -1
  const update = (progress) => {
    const idx = Math.min(
      wrappers.length - 1,
      Math.round(progress * (wrappers.length - 1)),
    )
    if (idx !== lastActive) {
      lastActive = idx
      const src = wrappers[idx].getAttribute('data-lottie-animation')
      if (src) swap(src)
    }
  }

  const targets = animationBlock ? [itemsWrap, animationBlock] : [itemsWrap]

  const remPx = () =>
    parseFloat(getComputedStyle(document.documentElement).fontSize) || 16
  const pinOffsetPx = () => 4 * remPx()

  gsap.to(targets, {
    x: () => -((pageCount - 1) * window.innerWidth),
    ease: 'none',
    scrollTrigger: {
      trigger: body,
      start: () => `top ${pinOffsetPx()}px`,
      end: () => `+=${(pageCount - 1) * window.innerWidth}`,
      pin: body,
      pinSpacing: true,
      pinType: 'fixed',
      // Refresh this pin BEFORE triggers below it (e.g. .cite) so they see the
      // added pin spacer and compute their start/end correctly.
      refreshPriority: 1,
      scrub: 1,
      invalidateOnRefresh: true,
      onRefreshInit: () => measureMaxHeight(),
      onUpdate: (self) => update(self.progress),
    },
  })

  window.addEventListener('load', () => ScrollTrigger.refresh())
})

document.addEventListener('DOMContentLoaded', function () {
  var banner = document.querySelector('.cookie-banner')
  if (!banner) return

  var KEY = 'cookie_consent'
  var saved = null
  try {
    saved = localStorage.getItem(KEY)
  } catch (e) {}

  if (saved !== 'granted' && saved !== 'denied') {
    banner.classList.add('is-active')
  }

  function setConsent(state) {
    try {
      localStorage.setItem(KEY, state)
    } catch (e) {}

    gtag('consent', 'update', {
      ad_storage: state,
      ad_user_data: state,
      ad_personalization: state,
      analytics_storage: state,
    })

    banner.classList.remove('is-active')
  }

  var accept = banner.querySelector('[data-cookie="accept"]')
  var decline = banner.querySelector('[data-cookie="decline"]')

  if (accept)
    accept.addEventListener('click', function (e) {
      e.preventDefault()
      setConsent('granted')
    })
  if (decline)
    decline.addEventListener('click', function (e) {
      e.preventDefault()
      setConsent('denied')
    })
})
